module.exports = __webpack_public_path__ + "static/media/Cum să te reinventezi în vremuri incerte.0168e5e0.png";